module.exports = "<div ng-if=\"item()\">{{ {amount: item().getValue(), currency: item().getPropertyInfo().getCurrency()} | gwCurrency }}</div>"